var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeptop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3351 12.7182V2.59088C20.3351 1.66298 19.58 0.9 18.6581 0.9H3.33865C2.41675 0.9 1.66172 1.66298 1.66172 2.59088V12.7182H0.860677C0.709076 12.7182 0.572225 12.7897 0.4746 12.8905C0.377222 12.9911 0.311452 13.1284 0.31016 13.2718H0.310156V13.2727V14.1818C0.310156 15.2356 1.16575 16.1 2.21244 16.1H19.7843C20.831 16.1 21.6866 15.2356 21.6866 14.1818V13.2727C21.6866 12.9804 21.428 12.7182 21.1361 12.7182H20.3351ZM3.33865 2.00902C3.33867 2.00902 3.3387 2.00902 3.33873 2.00902H18.6577C18.9839 2.00902 19.2336 2.25971 19.2336 2.59088V12.7182H2.76284V2.59088C2.76284 2.25975 3.01256 2.00906 3.33865 2.00902ZM1.41123 13.8273H20.5853V14.1818C20.5853 14.6389 20.2352 14.9908 19.7843 14.9908H2.2124C1.7615 14.9908 1.41136 14.6388 1.41136 14.1818V14.1818L1.41123 13.8273Z",
    fill: "#939090",
    stroke: "#939090",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeptop);
export default __webpack_public_path__ + "static/media/Leptop.f9db5716479a727b712e1b78b01a5aa3.svg";
export { ForwardRef as ReactComponent };